import React from "react"

import { Button, Flex, useDisclosure, VStack } from "@chakra-ui/react"
import { ReceiptModal } from "./ReceiptModal"
//import { useSelector } from "react-redux";

export const PrintReceiptButton = ({
  nextStep,
  userProfile,
  showSuccessPage,
  setShowSuccessPage,
  unit,
  unitLabel,
  unitPurchased,
  amountPaid,
  amountCal,
  utilityType,
}) => {
  // const pageColor = useSelector(
  //   (state) => state?.switchTab?.currentDisplay?.pageColor
  // );

  // const handleSubmit = () => {
  //   nextStep()
  // }
  const { isOpen, onOpen, onClose } = useDisclosure()
  console.log("showSuccessPage", showSuccessPage)

  const handlePrintBadge = () => {
    onOpen()
    setShowSuccessPage(true)

    // timeOut()
  }

  return (
    <Flex align={"center"} justify={"center"} w="100%" mt="30px">
      <VStack>
        <ReceiptModal
          isOpen={isOpen}
          onClose={onClose}
          userProfile={userProfile}
          nextStep={nextStep}
          setShowSuccessPage={setShowSuccessPage}
          amountPaid={amountPaid}
          unitPurchased={unitPurchased}
          unit={unit}
          unitLabel={unitLabel}
          amountCal={amountCal}
          utilityType={utilityType}
        />
        <Button
          bg={"pageColor"}
          color={"#FFFFFF"}
          size="md"
          fontWeight="semibold"
          fontSize={"14px"}
          px="20px"
          onClick={handlePrintBadge}
        >
          Print Receipt
        </Button>
      </VStack>
    </Flex>
  )
}
